export const MAINNAVBARITEMS: { name: string, id: string }[] = [
    {name: 'Home', id: 'home'},
    // {name: 'About', id: 'about'},
    {name: 'Tours', id: 'tours'},
    {name: 'Service', id: 'service'},
  // {name: 'Faq', id: 'faq'},
    {name: 'Contact', id: 'contact'}
];
